import styled from 'styled-components';

const RedoButtonStyle = styled.button`
  appearance: none;
  border-radius: 3px;
  cursor: pointer;
  position: relative; // Added for positioning the loader
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 30px;
  min-width: 30px;
  background: transparent;
  border: 0px;
  border-left: 1px solid var(--borderLightColor);
  border-right: 0px;
  padding: 0 0.625rem 0 0.65rem;

  @media (max-width: 860px) {
    height: 30px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.7;
  }
`;

export { RedoButtonStyle };
